import bannerMask from '../assets/images/bannerMask.png';

function BannerMask() {
  return (
    <div className="banner-mask" data-aos="fade-in"
      data-aos-delay="300"
      data-aos-duration="1200">
      <img src={bannerMask} alt="Banner Mask" />
    </div>
  );
}

export default BannerMask;
